import React, { useState } from "react";
import { motion } from "framer-motion";
import { FilloutPopupEmbed } from "@fillout/react";

import "../components/Styles/new.css";

import ov11 from "../assets/images/ov11.png";
import ov22 from "../assets/images/ov22.png";
import ov44 from "../assets/images/ov44.png";
import ov55 from "../assets/images/ov55.png";
import Xp from "../assets/images/xp.png";

import AOS from "aos";
import "aos/dist/aos.css";


import {
  FaUserPlus,
  FaUsers,
  FaPhoneAlt,
  FaDollarSign,
  FaPaperPlane,
  FaCheckCircle,
  FaArrowRight,
  FaCalendarAlt,
} from "react-icons/fa";

const steps = [
  {
    no: "01",
    icon: <FaUserPlus />,
    title: "Join the Partner Program",
    text: "Complete the short registration below.",
  },
  {
    no: "02",
    icon: <FaUsers />,
    title: "Refer Your Clients",
    text: "Send us clients who need professional workspace or business address solutions.",
  },
  {
    no: "03",
    icon: <FaPhoneAlt />,
    title: "We Take It From There",
    text: "Our team will contact your referral, understand their needs, and help them find the right solution.",
  },
  {
    no: "04",
    icon: <FaDollarSign />,
    title: "You Get Paid",
    text: "Commission is paid after the client's first full month of paid rent and first payment.",
  },
];

const benefits = [
  "Commission equal to first full month of paid rent",
  "Dedicated partner support team",
  "Flexible workspace options for every client",
  "Fast commission payment within 60 days",
];

const features = [
  {
    icon: ov55,
    title: "Private Offices",
  },
  {
    icon: ov11,
    title: "Virtual Offices",
  },
  {
    icon: ov22,
    title: "Meeting Rooms",
  },
  {
    icon: ov44,
    title: "Flexible Workspace Solutions",
  },
];

const Newpage = () => {
  const [partnerFormOpen, setPartnerFormOpen] = useState(false);

  React.useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div>

      {/* ================= HERO SECTION ================= */}

      <section className="referral-section">
        <div className="wid">
          <div className="overlay">
            <div className="content">

              <span className="tag">
                REALTOR PARTNER PROGRAM
              </span>

              <h1>
                Refer Clients. <span>Earn Commission.</span>
              </h1>

              <p>
                Your clients already come to you for trusted real estate
                guidance. When they also need a professional place to work,
                meet, or establish their business, connect them with Xceed
                Office.
              </p>

              <p>
                Refer a qualified client to Xceed Office and earn a commission
                equal to their{" "}
                <strong style={{ color: "white" }}>
                  first full month of paid rent
                </strong>{" "}
                when they become an eligible Xceed client.
              </p>

              <div className="feature-grid">

                {features.map((item, index) => (
                  <div className="feature-card" key={index}>

                    <div className="icon">
                      <img
                        src={item.icon}
                        alt={item.title}
                      />
                    </div>

                    <span>
                      {item.title}
                    </span>

                  </div>
                ))}

              </div>

            </div>
          </div>
        </div>
      </section>


      {/* ================= HOW IT WORKS ================= */}

      <section className="partner-section">

        <div className="container">

          <span className="section-tag">
            HOW IT WORKS
          </span>

          <h2 className="section-title">
            A Simple Partnership for{" "}
            <span>Serious Professionals</span>
          </h2>


          <div className="steps-grid">

            {steps.map((step) => (

              <div
                className="step-card"
                key={step.no}
              >

                <div className="step-top">

                  <div className="step-icon">
                    {step.icon}
                  </div>

                  <span className="step-number">
                    {step.no}
                  </span>

                </div>

                <h4>
                  {step.title}
                </h4>

                <p>
                  {step.text}
                </p>

              </div>

            ))}

          </div>


          {/* ================= PARTNER GUIDE ================= */}

          <div className="bottom-grid">

            <div className="left-content">

              <span className="section-tag">
                BECOME A PARTNER
              </span>

              <h3>
                Become an Xceed Office{" "}
                <span>Realtor Partner</span>
              </h3>

              <p>
                Download our Partner Guide to learn how the program works,
                review commission details, and start referring clients with
                confidence.
              </p>

              <ul>

                {benefits.map((item, index) => (

                  <li key={index}>

                    <FaCheckCircle />

                    {item}

                  </li>

                ))}

              </ul>

            </div>


            <div className="guide-card">

              <div className="guide-icon">
                <FaPaperPlane />
              </div>

              <h4>
                Get the Partner Guide
              </h4>

              <p>
                Everything you need to know about referring clients and
                earning commission with Xceed Office.
              </p>

              <a
                href="/files/Xceed%20Office%20Flyer.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="guide-download-btn"
              >
                DOWNLOAD PARTNER GUIDE{" "}
                <FaArrowRight />
              </a>

            </div>

          </div>

        </div>

      </section>


      {/* ================= CTA SECTION ================= */}

      <section className="partner-section">

        <div className="partner-hero">

          <div className="partner-overlay">

            <h2>
              Ready to Partner with{" "}
              <span>Xceed Office?</span>
            </h2>

            <p>
              Join our Realtor Partner Program today and start earning
              commission by connecting your clients with a workspace solution
              they can trust.
            </p>


            <div className="partner-buttons">

              {/* JOIN PARTNER BUTTON */}

              <button
                type="button"
                className="partner-btn primary"
                onClick={() => setPartnerFormOpen(true)}
              >
<span><FaCalendarAlt /></span>

                Join the Partner Program

                <span>→</span>

              </button>


              {/* FILLOUT POPUP */}

              <FilloutPopupEmbed
                filloutId="7WFdeJ7xPMus"
                isOpen={partnerFormOpen}
                onClose={() => setPartnerFormOpen(false)}
                inheritParameters
              />


              {/* CALL BUTTON */}

              <a
                href="tel:346-502-2552"
                className="partner-btn secondary"
              >

               <span><FaPhoneAlt /></span>

                Call 346-502-2552

              </a>

            </div>

          </div>

        </div>


        {/* ================= CLIENT SECTION ================= */}

        <div className="client-section">

          <div className="client-content">

            <div className="client-text">

              <div className="eyebrow">
                FOR YOUR CLIENTS
              </div>

              <h2>
                A Better Workspace Option for{" "}
                <span>Your Clients</span>
              </h2>

              <p>
                Whether your client needs a private office, a professional
                business address, a place to meet customers, or a more
                flexible alternative to a traditional lease, Xceed gives you
                another solution you can confidently recommend.
              </p>


              <div className="office-card">

                <div className="office-icon">
                  ⌂
                </div>

                <div>

                  <h3>
                    Xceed Office
                  </h3>

                  <p className="address">
                    3050 Post Oak Blvd, Suite 1500
                    <br />
                    Houston, Texas
                  </p>

                  <a href="mailto:info@xceedoffice.com">
                    ✉ info@xceedoffice.com
                  </a>

                </div>

              </div>

            </div>


            <div className="client-image">

              <img
                src={Xp}
                alt="Xceed Office"
              />

            </div>

          </div>

        </div>

      </section>

    </div>
  );
};

export default Newpage;